const SelectInput = ({
    label,
    name,
    value,
    onChange,
    isRequired = false,
    disabled = false,
    children
}) => {
    return (
        <div>
            <label className="block text-sm font-medium text-gray-700">
                {label} {isRequired && <span className="text-red-500">*</span>}
            </label>

            <select
                name={name}
                value={value || ""}
                onChange={onChange}
                disabled={disabled}
                required={isRequired}
                className="mt-1 py-[7px] px-[10px] block w-full border border-gray-200 rounded-md shadow-sm focus:ring-brand-red focus:border-brand-red"
            >
                {children}
            </select>
        </div>
    );
};

export default SelectInput